// Shown wherever a device picker would otherwise sit empty with no explanation. Device
// *management* routes already gate on READ:DEVICE:PROD (src/routes.ts), so this is for the
// pages reachable on other scopes — usage, ESG, invoice, home — that still list devices.
//
// A leaf module on purpose: six of its seven consumers want the string and not the notice,
// and importing copy should not pull in a component, its hook, or the device query layer.
//
// The text is asserted verbatim by tests/e2e/auth/device-scope-gate.spec.ts. Changing it
// is a test change too.
export const DEVICE_ACCESS_DENIED_MESSAGE =
  'You do not have access to device data. Contact your account administrator.'

// For the add-device timezone picker only. `/account-management` gates on READ:ACCOUNT,
// and neither New Device scope implies the READ:DEVICE:PROD that `/devices/timezones`
// requires — so that control is reachable with the query disabled. Device Management is
// not: `/device-management` already gates on READ:DEVICE:PROD (src/routes.ts).
export const TIMEZONE_ACCESS_DENIED_MESSAGE =
  'You do not have access to timezone data. Contact your account administrator.'
